// Translations
export const translations = {
  de: {
    dashboard: 'Dashboard',
    agents: 'Agenten',
    sessions: 'Sitzungen',
    transcripts: 'Transkripte',
    settings: 'Einstellungen',
    billing: 'Abrechnung',
    totalAgents: 'Gesamt Agenten',
    activeSessions: 'Aktive Sitzungen',
    totalCalls: 'Gesamte Anrufe',
    callDuration: 'Gesprächszeit',
    createAgent: 'Agent erstellen',
    editAgent: 'Agent bearbeiten',
    deleteAgent: 'Agent löschen',
    agentName: 'Agent Name',
    description: 'Beschreibung',
    systemPrompt: 'System Prompt',
    knowledgeBase: 'Wissensbasis',
    voice: 'Stimme',
    language: 'Sprache',
    tools: 'Tools',
    addTool: 'Tool hinzufügen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    recentSessions: 'Letzte Sitzungen',
    noAgents: 'Keine Agenten vorhanden',
    noSessions: 'Keine Sitzungen vorhanden',
    toolConfig: 'Tool Konfiguration',
    triggerCondition: 'Auslösebedingung',
    triggerConditionHelp: 'Wann soll der Agent dieses Tool verwenden?',
    minutes: 'Minuten',
    seconds: 'Sekunden',
    caller: 'Anrufer',
    duration: 'Dauer',
    status: 'Status',
    phoneNumber: 'Telefonnummer',
    welcome: 'Willkommen bei VoiceAgent',
    welcomeDesc: 'Erstellen und verwalten Sie intelligente Telefon-Agenten',
    twilioConfig: 'Twilio Konfiguration',
    twilioSetup: 'Twilio einrichten',
    webhookUrl: 'Webhook URL',
    copyUrl: 'URL kopieren',
    copied: 'Kopiert!',
    twilioInstructions: 'Twilio Einrichtungsanleitung',
    connectTwilio: 'Mit Twilio verbinden',
    twilioConnected: 'Twilio verbunden',
    testCall: 'Testanruf',
    login: 'Anmelden',
    logout: 'Abmelden',
    loginWithGoogle: 'Mit Google anmelden',
    welcomeBack: 'Willkommen zurück',
    loginDesc: 'Melden Sie sich an, um Ihre Agenten zu verwalten',
    credits: 'Credits',
    plan: 'Tarif',
    upgrade: 'Upgrade',
  },
  en: {
    dashboard: 'Dashboard',
    agents: 'Agents',
    sessions: 'Sessions',
    transcripts: 'Transcripts',
    settings: 'Settings',
    billing: 'Billing',
    totalAgents: 'Total Agents',
    activeSessions: 'Active Sessions',
    totalCalls: 'Total Calls',
    callDuration: 'Call Duration',
    createAgent: 'Create Agent',
    editAgent: 'Edit Agent',
    deleteAgent: 'Delete Agent',
    agentName: 'Agent Name',
    description: 'Description',
    systemPrompt: 'System Prompt',
    knowledgeBase: 'Knowledge Base',
    voice: 'Voice',
    language: 'Language',
    tools: 'Tools',
    addTool: 'Add Tool',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    active: 'Active',
    inactive: 'Inactive',
    recentSessions: 'Recent Sessions',
    noAgents: 'No agents available',
    noSessions: 'No sessions available',
    toolConfig: 'Tool Configuration',
    triggerCondition: 'Trigger Condition',
    triggerConditionHelp: 'When should the agent use this tool?',
    minutes: 'minutes',
    seconds: 'seconds',
    caller: 'Caller',
    duration: 'Duration',
    status: 'Status',
    phoneNumber: 'Phone Number',
    welcome: 'Welcome to VoiceAgent',
    welcomeDesc: 'Create and manage intelligent phone agents',
    twilioConfig: 'Twilio Configuration',
    twilioSetup: 'Setup Twilio',
    webhookUrl: 'Webhook URL',
    copyUrl: 'Copy URL',
    copied: 'Copied!',
    twilioInstructions: 'Twilio Setup Instructions',
    connectTwilio: 'Connect Twilio',
    twilioConnected: 'Twilio Connected',
    testCall: 'Test Call',
    login: 'Login',
    logout: 'Logout',
    loginWithGoogle: 'Login with Google',
    welcomeBack: 'Welcome back',
    loginDesc: 'Sign in to manage your agents',
    credits: 'Credits',
    plan: 'Plan',
    upgrade: 'Upgrade',
  }
};

export default translations;
